// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vgeOuaa7IR0Se6 {
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 272px;
  margin-bottom: 20px;
  padding: 9px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
}
.vgeOuaa7IR0Se6 .vRcCoi42_7PKwX {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 24px 30px 24px 42px;
  border: dashed var(--ds-border-information, #1d7afc) 2px;
  border-radius: 3px;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .vgeOuaa7IR0Se6 .vRcCoi42_7PKwX {
    flex-direction: column-reverse;
  }
}
.vgeOuaa7IR0Se6 .YFvC2yBd0fMYMR {
  width: 100%;
  max-width: 323px;
}
.vgeOuaa7IR0Se6 .otQEIKuy3TLflT {
  margin-right: 21px;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .vgeOuaa7IR0Se6 .otQEIKuy3TLflT {
    width: inherit;
    text-align: center;
  }
  .vgeOuaa7IR0Se6 .otQEIKuy3TLflT h1 {
    margin-top: 28px;
    color: var(--ds-text, #172b4d);
    font-size: 20px;
    letter-spacing: -0.008em;
    line-height: 24px;
    font-weight: var(--ds-font-weight-semibold, 600);
  }
}
.vgeOuaa7IR0Se6 .md7xRsjCksHNrU {
  font-size: 29px;
  line-height: 32px;
}
.vgeOuaa7IR0Se6 .EZYnpkr1xn1e6s {
  color: var(--ds-text-subtle, #44546f);
  font-size: 14px;
  line-height: 20px;
}
@media not only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .vgeOuaa7IR0Se6 .EZYnpkr1xn1e6s {
    max-width: 372px;
  }
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .vgeOuaa7IR0Se6 .EZYnpkr1xn1e6s {
    margin-right: auto;
    margin-left: auto;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `vgeOuaa7IR0Se6`,
	"bannerBorder": `vRcCoi42_7PKwX`,
	"bannerIcon": `YFvC2yBd0fMYMR`,
	"bannerText": `otQEIKuy3TLflT`,
	"bannerHeading": `md7xRsjCksHNrU`,
	"bannerParagraph": `EZYnpkr1xn1e6s`
};
export default ___CSS_LOADER_EXPORT___;
